import { type KeyboardConfig, useKeyboardNavigation } from "@tour-kit/react";

/**
 * tour-kit ships a `keyboard` config + `useKeyboardNavigation` hook but the
 * provider never calls the hook, so `MultiTourKitProvider` `config.keyboard` is
 * inert. We wire it here instead:
 * - Esc  → exit the tour (`skip()`, same as the Skip button → `tour_skipped`)
 * - Enter → next step
 * - arrows / prev disabled so they don't clash with dashboard DataGrids/charts
 *
 * The hook ignores keys while focus is in an input/select/textarea/contenteditable.
 */
const TOUR_KEYBOARD: KeyboardConfig = {
  enabled: true,
  nextKeys: ["Enter"],
  prevKeys: [],
  exitKeys: ["Escape"],
};

const TourKeyboard = () => {
  useKeyboardNavigation(TOUR_KEYBOARD);
  return null;
};

export default TourKeyboard;
